<script>
import ValidateMixin from './mixins/validate'

export default {
  name: 'RnrInput',
  mixins: [ValidateMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    attrs: {
      type: Object,
      default: () => ({})
    },
    rules: {
      type: Array,
      default: () => ([])
    },
    validateCallback: {
      type: Function,
      default: null
    }
  },
  methods: {
    /**
     * 触发blur的方法
     */
    handleBlur() {
      // 开始校验
      this.validate()
    }
  },
  render() {
    return (
      <van-field
        value={this.value}
        clearable={true}
        required={this.required}
        clear-trigger='always'
        label={this.label}
        placeholder={`请输入${this.label}`}
        input-align='right'
        onInput={val => this.$emit('input', val)}
        onBlur={this.handleBlur}
        {...(this.attrs || {})}
      />
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormRender/input.vue